"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullToUndefined = nullToUndefined;
function nullToUndefined(value) {
    return value === null ? undefined : value;
}
//# sourceMappingURL=nullToUndefined.js.map